export default "__VITE_ASSET__ecb6868f__"